import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import ListHeaders from "components/menu/master-files/question-library/list-headers";
import ListQuestions from "components/menu/master-files/question-library/list-questions";

class QuestionLibrary extends React.Component {
    tabs = {
        questions: "questions",
        headers: "headers"
    };

    render() {
        return (
            <div className="dashboard">
                <Tabs
                    id="question-library-tabs"
                    defaultActiveKey={this.tabs.questions}
                    className="w-100"
                    unmountOnExit={true}
                >
                    <Tab
                        eventKey={this.tabs.questions}
                        title="Questions"
                    >
                        <ListQuestions />
                    </Tab>
                    <Tab
                        eventKey={this.tabs.headers}
                        title="Headers"
                    >
                        <ListHeaders />
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

export default QuestionLibrary;
